import React from 'react';
import { useSelector } from 'react-redux';
import WelcomeMenus from '../../WelcomeMenus';
import UploadHiringPartnerForm from './UploadHiringPartnerForm';

const AddNewHiringPartner = () => {
  const { user } = useSelector((s) => s.auth);
  return (
    <div>
      {user?.role_id === 1 ? <UploadHiringPartnerForm /> : (
        <>
          <h2>Admin only</h2>
          <WelcomeMenus />
        </>
      )}
    </div>
  );
};

export default AddNewHiringPartner;
